import { useState, useEffect } from "react";
import Avatars from "./../../../assets/images/avatars.png";
import JamesLogo from "./../../../assets/images/james-logo2.png";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { BiArrowBack, BiErrorCircle } from "react-icons/bi";

import MaleIcon from "./../../../assets/icons/male.svg";
import FemaleIcon from "./../../../assets/icons/female.svg";
import NoIdentityIcon from "./../../../assets/icons/user_icon.svg";
import { useSignupEffect } from "./effect";
import { useMutation } from "react-query";
import { signUp } from "../../../api/user";
import { showErrorToast } from "../../../utils/toast";

const pointer = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="335"
    height="102"
    viewBox="0 0 335 102"
    fill="none"
  >
    <path
      d="M332.729 3.61423C332.727 3.66323 332.724 3.71221 332.719 3.76297C332.637 4.55058 332.104 5.20344 331.592 5.80552C318.782 20.9083 303.385 38.1656 288.239 50.9002C242.42 89.4299 178.463 107.282 119.338 98.4418C98.6942 95.3544 78.5245 88.7228 60.1473 78.7657C51.2113 73.9246 42.4007 67.6167 34.4315 60.9028C26.6451 54.3412 18.3693 46.1046 10.4627 38.9339C10.2746 38.7641 9.96277 38.9304 9.92793 39.1825C9.52729 42.1264 5.6864 54.98 5.30144 55.9217C3.57346 60.1537 -0.269221 59.6409 0.45019 54.6318C1.29676 48.7387 2.55619 43.9781 3.96017 38.2741C4.43049 36.3594 5.01053 32.2008 6.46677 30.8776C8.19126 29.3112 10.7205 29.6944 13.046 29.6192C18.2839 29.4459 24.2169 28.9383 29.4722 29.4617C34.3165 29.9447 38.9448 34.6214 30.979 34.8121C25.7672 34.9364 19.944 35.0607 14.6903 34.8909C14.4987 34.8839 14.4029 35.1167 14.5457 35.2444C17.7108 38.0763 22.9993 43.4705 25.5372 46.2219C65.5421 89.5979 139.002 103.222 196.057 90.0757C207.226 87.5029 218.202 84.0759 228.85 79.8229C267.686 64.3105 302.277 32.57 325.237 4.97762C326.359 3.62994 327.315 1.97601 328.974 1.42293C330.585 0.885611 332.771 1.95151 332.729 3.61423Z"
      fill="#00EFC1"
    />
  </svg>
);

export default function Register() {
    const navigate = useNavigate();

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);

    const ref = params.get("ref");

    if (ref) {

      localStorage.setItem("referralCode", ref);

    }

    const customSchemeUrl = `jamestown://register?ref=${ref || ""}`;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const isAndroid = /Android/.test(navigator.userAgent);

    const androidFallback =

      "https://play.google.com/store/apps/details?id=com.jamestown.app.jamestown.jamestown";

    const iosFallback =

      "https://apps.apple.com/app/id6757491494";

    window.location.href = customSchemeUrl;

    const timer = setTimeout(() => {

      if (isIOS) {

        window.location.href = iosFallback;

      } else if (isAndroid) {

        window.location.href = androidFallback;

      }

    }, 2000);

    return () => clearTimeout(timer);

  }, []);
  
  const [signupErrors, setSignupErrors] = useState([]);
  const [isGenderPage, setGenderPage] = useState(false);

  const { createAccount } = useSignupEffect(
    setSignupErrors,
    isGenderPage,
    setGenderPage
  );

  const mutation = useMutation(signUp, {
    onSuccess: () => {
      navigate("/verify-account")
    },
    onError: (e) => showErrorToast(e.message),
  });

  const onSubmit = (e) => {
    const data = createAccount(e);
    if (data?.submit) {
        localStorage.setItem("user-ph", data.formData.get("phoneNumber"))
      const referralCode = localStorage.getItem("referralCode");

if (referralCode) {
  data.formData.append("referralCode", referralCode);
}
        mutation.mutate(data.formData);
    }
  };

  return (
    <div className=" w-full h-full">
      <div className="h-full flex w-full">
        <div className="sm:w-1/2 w-full flex flex-col items-center h-full">
          <div className="sm:w-1/2 w-full sm:p-0 p-3 h-full py-10 flex flex-col gap-6 relative overflow-y-auto">
            <Link to={"/"}>
              <img src={JamesLogo} className="w-1/2" alt="logo" />
            </Link>
            <div className={classNames("space-y-3", { hidden: isGenderPage })}>
              <div className="font-bold text-[#101828] text-[34px]">
                Sign up
              </div>
              <div className="text-[#667085] text-[16px]">
                Create your Jamestown account
              </div>
            </div>
            <div className="w-full flex flex-col items-center">
              <div
                className={classNames(
                  "w-full p-3 bg-[#ff4c4c] mb-3 rounded-lg flex text-white gap-3",
                  {
                    hidden: signupErrors.length === 0,
                  }
                )}
              >
                <div className="text-[20px]">
                  <BiErrorCircle />
                </div>
                <div className="space-y-1 text-[14px] font-dmsans font-medium text-start">
                  {signupErrors.map((error, index) => {
                    return <div key={index}>{error}</div>;
                  })}
                </div>
              </div>

              <form className="w-full" onSubmit={onSubmit}>
                <div
                  className={classNames("flex flex-col gap-6 w-full", {
                    "!hidden": isGenderPage,
                  })}
                >
                  <div className="flex gap-5">
                    <div className="flex flex-col gap-1 items-start w-1/2">
                      <div className="text-[#344054] text-[14px] font-medium">
                        First name
                      </div>
                      <div className="w-fit">
                        <input
                          type="text"
                          name="firstName"
                          className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                          placeholder="First Name"
                          required
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-1 items-start w-1/2">
                      <div className="text-[#344054] text-[14px] font-medium">
                        Last name
                      </div>
                      <div className="w-fit">
                        <input
                          type="text"
                          name="lastName"
                          className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                          placeholder="Last Name"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-1 items-start w-full">
                    <div className="text-[#344054] text-[14px] font-medium">
                      Email
                    </div>
                    <div className="w-full">
                      <input
                        type="email"
                        name="email"
                        className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                        placeholder="akpusugh@stow.com"
                        required
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-1 items-start w-full">
                    <div className="text-[#344054] text-[14px] font-medium">
                      Phone number
                    </div>
                    <div className="w-full flex items-center gap-2">
                      <select
                        name="country-code"
                        className="w-1/3 border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] text-[#6C798F]"
                        disabled
                      >
                        <option value="234">+234</option>
                      </select>
                      <input
                        type="text"
                        name="ph-number"
                        className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                        placeholder="812 345 6789"
                        required
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-1 items-start w-full">
                    <div className="text-[#344054] text-[14px] font-medium">
                      Password
                    </div>
                    <div className="w-full">
                      <input
                        type="password"
                        name="password"
                        className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                        placeholder="Password"
                        required
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-1 items-start w-full">
                    <div className="text-[#344054] text-[14px] font-medium">
                      Confirm Password
                    </div>
                    <div className="w-full">
                      <input
                        type="password"
                        name="cpassword"
                        className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                        placeholder="Confirm Password"
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* Gender Page */}
                <div
                  className={classNames(
                    "w-full flex flex-col gap-10 mb-8 mt-16",
                    { "!hidden": !isGenderPage }
                  )}
                >
                  <div className="flex flex-col gap-3">
                    <div className="text-[#14142B] font-dmsans text-[18px] font-bold">
                      Select your gender
                    </div>
                    <div className="text-[#4E4B66] font-dmsans text-[16px]">
                      For a more personalised experience in sections within the
                      app
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 text-[#4E4B66] text-[15px] px-6">
                    <label for="maleRadio" className="w-full">
                      <div className="flex px-6 py-3 items-center bg-[#EFF0F6] rounded-[5px] gap-3">
                        <img src={MaleIcon} alt="Male"></img>
                        <div>Male</div>
                        <input
                          type="radio"
                          value={"male"}
                          name="gender"
                          id="maleRadio"
                          className="ml-auto"
                        />
                      </div>
                    </label>
                    <label for="femaleRadio" className="w-full">
                      <div className="flex px-6 py-3 items-center bg-[#EFF0F6] rounded-[5px] gap-3">
                        <img src={FemaleIcon} alt="Female"></img>
                        <div>Female</div>
                        <input
                          type="radio"
                          value={"female"}
                          name="gender"
                          id="femaleRadio"
                          className="ml-auto"
                        />
                      </div>
                    </label>
                    <label for="noIdentityRadio" className="w-full">
                      <div className="flex px-6 py-3 items-center bg-[#EFF0F6] rounded-[5px] gap-3">
                        <img src={NoIdentityIcon} alt="No Identity"></img>
                        <div>I choose not to identify</div>
                        <input
                          type="radio"
                          value={"no-identity"}
                          name="gender"
                          id="noIdentityRadio"
                          className="ml-auto"
                        />
                      </div>
                    </label>
                  </div>
                </div>

                <div className="mt-4 w-full flex">
                  <button
                  disabled={mutation.isLoading}
                    type="submit"
                    className={`w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3 ${mutation.isLoading ? "animate-pulse" :  ""}`}
                  >
                    {isGenderPage ? mutation.isLoading ? "Creating Account..." : "Create account" : "Continue"}
                  </button>
                </div>
              </form>
              <div className={classNames("py-5", { hidden: isGenderPage })}>
                <Link
                  to={"/login"}
                  className="font-inter text-[14px] text-[#667085]"
                >
                  Already have an account?{" "}
                  <span className="text-[#1EA68A] font-medium">Log in</span>
                </Link>
              </div>
              <div className={classNames("py-5", { hidden: !isGenderPage })}>
                <button
                  onClick={() => setGenderPage(false)}
                  className="font-inter text-[14px] text-[#667085]"
                >
                  <span className="text-[#1EA68A] font-medium flex items-center gap-3">
                    <BiArrowBack /> Back
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden w-1/2 fixed right-0 p-20 bg-dark h-full sm:flex sm:flex-col items-center justify-center">
          <div className="flex flex-col gap-4">
            <div className="mt-5 relative flex flex-col items-center justify-center">
              <div className="text-left">
                <div className=" font-dmsans font-medium md:text-[64px]">
                  <div className="text-white leading-[77.4px]">
                    Do a lot with one{" "}
                    <span className="text-jgreen font-Manrope font-bold">
                      Application
                    </span>
                  </div>
                </div>
                <div className="py-4">
                  <div className="text-white text-sm font-medium font-inter leading-7">
                    Create a free account and get full access to all features .
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <img src={Avatars} className="w-[120px]" aria-label="icon" />
              <div className="text-[#E4E7EC] font-inter text-[16px] font-medium">
                Join x+ users
              </div>
            </div>
            <div
              className={classNames("relative z-10", { hidden: isGenderPage })}
            >
              <div className="absolute left-[-45%]">{pointer}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
